import template from './preferences.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';
import * as Permissions from '../../lib/permission_utils.js';

class PreferencesViewModel
{
	constructor(page)
	{
		this.page = page;

		// Used to block updates to the DB from initial language setting
		this.language_retrieved = ko.observable(false);
		this.changed_email = ko.observableArray();
		this.changed_notification = ko.observableArray();
		this.selected_language = ko.observable();
		this.selected_theme = ko.observable();
		this.email_subscriptions = ko.observableArray();
		this.notification_subscriptions = ko.observableArray();
		this.colour_scheme = ko.observableArray();

		this.languages = ko.observableArray([
			{ language: 'English', code: 'en' },
			{ language: 'Afrikaans', code: 'af' },
			{ language: 'Zulu', code: 'zu' }
		]);

		this.result;
		localStorage.removeItem('company_colour_setting');
		this.get_current_theme();
	}

	render_handler() 
	{
		// email subscriptions
		let email_checkboxes = document.querySelectorAll('.email_subscription');
		email_checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', (event) => {
				let subscription = ko.dataFor(checkbox);
				subscription.subscribed = event.target.checked;
				this.changed_email.push({
					employee_id: subscription.employee_id,
					subscription_name: subscription.subscription_name,
					subscribed: event.target.checked,
					grape_user_id: subscription.grape_user_id
				});
			});
		});

		// notification subscriptions
		let notif_checkboxes = document.querySelectorAll('.notification_subscription');
		notif_checkboxes.forEach((checkbox) => {
			checkbox.addEventListener('change', (event) => {
				let subscription = ko.dataFor(checkbox);
				subscription.subscribed = event.target.checked;
				this.changed_notification.push({
					employee_id: subscription.employee_id,
					subscription_name: subscription.subscription_name,
					subscribed: event.target.checked,
					grape_user_id: subscription.grape_user_id
				});
			});
		});

	}

	async get_current_theme()
	{
		let select_scheme_data = await Grape.fetches.getJSON('/api/record', {
			table: 'setting_value',
			schema: 'grape',
			limit: 1,
			filter: [{ value: 'public.company_active_scheme', operand: '=', field: 'setting_name' },
			{ value: true, operand: '=', field: 'active' }]
		});

		switch (select_scheme_data.records[0].value.name) {
			case 'Default':
			case 'Yooma default':
				localStorage.setItem('company_colour_setting', 'Yooma default');
				break;
			case 'Pink':
			case 'Yooma pink':
				localStorage.setItem('company_colour_setting', 'Yooma pink');
				break;
			case 'Blue':
			case 'Yooma blue':
				localStorage.setItem('company_colour_setting', 'Yooma blue');
				break;
			case 'Purple':
			case 'Yooma purple':
				localStorage.setItem('company_colour_setting', 'Yooma purple');
				break;
			case 'Earth':
			case 'Yooma earth':
				localStorage.setItem('company_colour_setting', 'Yooma earth');
				break;
			case 'Classic':
			case 'Savanna classic':
				localStorage.setItem('company_colour_setting', 'Savanna classic');
				break;
			case 'Savanna Old':
			case 'Old':
				localStorage.setItem('company_colour_setting', 'Savanna classic');
				break;
			default:
				break;
		}
		this.selected_theme(localStorage.getItem('company_colour_setting'));
	}

	async save_changes()
	{
		// Save changed email subscriptions
		for (let data of this.changed_email())
			await Grape.fetches.postJSON('/settings/update_employee_email_subscriptions', data);

		// Save changed notification subscriptions
		for (let data of this.changed_notification())
			await Grape.fetches.postJSON('/settings/update_employee_notification_subscriptions', data);
		
		if (this.selected_theme())
		{
			let select_scheme_data = await Grape.fetches.getJSON('/api/record', {
				table: 'lookup_value',
				schema: 'grape',
				limit: 1,
				filter: [{ value: this.selected_theme(), operand: '=', field: 'name' }]
			});

			select_scheme_data.records[0].description = select_scheme_data.records[0].name;
			select_scheme_data.records[0].name = 'public.company_active_scheme';
			select_scheme_data.records[0].value = select_scheme_data.records[0].data;
			select_scheme_data.records[0].data_type = "text";

			await Grape.fetches.postJSON('/api/save_setting', select_scheme_data.records[0]);
			localStorage.setItem('company_colour_setting', this.selected_theme());
		
			await Grape.fetches.postJSON('/setting/set_color_scheme',{ scheme_name: this.selected_theme() });
		}

		if (this.selected_language())
		{
			let res = await Grape.fetches.postJSON('/language/set_user_language', {'language_code': this.selected_language()});

			if (res.status !== 'ERROR')
				localStorage.setItem('user_language_setting', this.selected_language());
		}

		localStorage.setItem('show_success_alert', 'true');
		location.reload();
	}
}

class PreferencesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new PreferencesViewModel(this);
	}

	async init()
	{
		document.title = tr('Preferences');
		window.current_page_title(tr('Preferences'));

		if (localStorage.getItem('show_success_alert') === 'true')
		{
			Grape.alerts.alert({ type: 'success', message: tr('New settings saved.'), title: tr('Success') });
			// Clear the flag
			localStorage.removeItem('show_success_alert');
		}

		let lookup = await Grape.fetches.getJSON('/api/record', { 
			table: 'lookup',
			schema: 'grape',
			limit: 1,
			filter: [{ value: 'colour_scheme_name', operand: '=', field: 'name' }]
		});

		let results = [];

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				schema: 'savanna',
				table: 'v_email_subscriptions_overview',
				limit: 100000,
				sortfield: 'subscription_name',
				sortorder: 'asc',
				filter: [{ field: 'employee_id', operand: '=', value: Utils.current_employee_id() }]
			});

			if (res.status !== 'ERROR')
				results.push(res.records);

			let res_sub = await Grape.fetches.getJSON('/api/record', {
				schema: 'savanna',
				table: 'v_notification_subscriptions_overview',
				limit: 100000,
				sortfield: 'subscription_name',
				sortorder: 'asc',
				filter: [{
					field: 'employee_id',
					operand: '=',
					value: Utils.current_employee_id()
				}]
			});

			if (res_sub.status !== 'ERROR')
				results.push(res_sub.records);

			let res_lookup = await Grape.fetches.getJSON('/api/record', {
				schema: 'grape',
				table: 'lookup_value',
				limit: 100000,
				filter: [{
					field: 'lookup_id',
					operand: '=',
					value: lookup.records[0].lookup_id
				},{
					field: 'name',
					operand: '!=',
					value: 'company_colour_scheme'
				}]
			});

			if (res_lookup.status !== 'ERROR')
				results.push(res_lookup.records);

			Grape.fetches.getJSON('/api/user_setting/language', {})
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Error occurred while loading settings...')});
		}

		//translate subscriptions
		if (results)
		{
			for (let i = 0; i < results[0].length; i++)
			{
				results[0][i].subscription_name = tr(results[0][i].subscription_name)
				results[0][i].desciption = tr(results[0][i].desciption)
				results[0][i].visible = true;

				if (results[0][i].feature_control) 
					results[0][i].visible = await Permissions.checkAccessRights(results[0][i].feature_control);
			}

			for (let i = 0; i < results[1].length; i++)
			{
				results[1][i].subscription_name = tr(results[1][i].subscription_name);
				results[1][i].desciption = tr(results[1][i].desciption);
				results[1][i].visible = true;

				if (results[1][i].feature_control)
					results[1][i].visible = await Permissions.checkAccessRights(results[1][i].feature_control);
			}

			this.viewModel.email_subscriptions(results[0]);
			this.viewModel.notification_subscriptions(results[1]);
			this.viewModel.colour_scheme(results[2]);

			let lan_code = localStorage.getItem('user_language_setting');
			let company_scheme = localStorage.getItem('company_colour_setting');
			this.viewModel.selected_language(lan_code);
			this.viewModel.selected_theme(company_scheme);
			this.viewModel.language_retrieved(true);
		}

		this.viewModel.render_handler();
	}
}

export default {
	route: '[/]settings/preferences',
	page_class: PreferencesPage,
	template: template,
	template_filename: 'translation/preferences'
};
